<script>
    export let updateBillingRulesPhase = () => {};
</script>

<div class="flex flex-col gap-y-4 p-6 w-full">
    <div class="flex flex-col gap-y-4">
        <div class="flex justify-center">
            <img src="/imgs/illi_4@2x.png" alt="img" />
        </div>

        <div class="flex flex-col gap-y-4">
            <p class="text-[20px] font-bold">Billing Rules</p>

            <p class="text-[16px]">
                Help us to understand how you normally bill patients.
            </p>

            <p class="text-[16px]">
                Anaemate will use your normal billing rules to help you automate
                your billing process
            </p>
        </div>
    </div>

    <!-- svelte-ignore a11y-missing-attribute -->
    <!-- svelte-ignore a11y-missing-content -->
    <div class="flex w-full justify-center">
        <div class="tabs flex gap-x-4 pb-4">
            <a class="tab tab-bordered tab-active cursor-default" />
            <a class="tab tab-bordered cursor-default" />
            <a class="tab tab-bordered cursor-default" />
            <a class="tab tab-bordered cursor-default" />
        </div>
    </div>

    <button
        class="btn btn-md btn-secondary"
        on:click|preventDefault={() => updateBillingRulesPhase(2)}
    >
        Next
    </button>
</div>

<style>
    img {
        width: 300px;
        height: 300px;
    }
</style>
